import md5 from 'blueimp-md5'

export default (email, size) => {
  return `https://www.gravatar.com/avatar/${md5(email)}?s=${size}&r=pg&d=identicon`
}
